import { motion } from "framer-motion";
import { Instagram, Heart, TrendingUp, Users } from "lucide-react";

const METRICS = [
  { icon: TrendingUp, value: "+312%", label: "Avg. engagement lift" },
  { icon: Users, value: "+48k", label: "Followers grown / yr" },
  { icon: Heart, value: "4.9M", label: "Impressions delivered" },
];

export const SocialCampaign = () => {
  return (
    <section data-testid="social-section" className="relative py-24 sm:py-32 border-t border-line overflow-hidden">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="mono-label text-accent flex items-center gap-2">
              <Instagram className="w-4 h-4" /> Social Media Campaigns
            </span>
            <h2 className="font-head font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-5 text-balance">
              Campaigns that stop the scroll & start the sale.
            </h2>
            <p className="text-text-2 text-lg leading-relaxed mt-6 max-w-lg">
              From strategy to short-form video, we run full-funnel social campaigns across
              Instagram, TikTok, Facebook, and LinkedIn — building audiences that convert into
              paying customers right here in Sacramento.
            </p>

            <div className="grid grid-cols-3 gap-px bg-line border border-line mt-10">
              {METRICS.map((m) => (
                <div key={m.label} className="bg-surface p-5">
                  <m.icon className="w-5 h-5 text-accent mb-3" />
                  <div className="font-head font-black text-2xl sm:text-3xl">{m.value}</div>
                  <div className="mono-label text-text-2 mt-1 !text-[0.6rem]">{m.label}</div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="grid grid-cols-2 gap-4">
              <div className="relative border border-line overflow-hidden col-span-2">
                <img src="/assets/social-hero.png" alt="Campaign creative — Your Website Needs A Hero" className="w-full h-full object-cover" />
                <div className="absolute top-3 left-3 bg-accent text-ink px-3 py-1 font-head font-bold text-xs flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-ink animate-pulse" /> CAMPAIGN LIVE
                </div>
              </div>
              <div className="relative border border-line overflow-hidden">
                <img src="/assets/social-local.png" alt="Campaign creative — Sacramento's Official Partner" className="w-full h-full object-cover" />
              </div>
              <div className="relative border border-line overflow-hidden">
                <img src="/assets/social-consult.png" alt="Campaign creative — Free Consultation" className="w-full h-full object-cover" />
              </div>
            </div>
            <div className="absolute -top-4 -right-4 w-24 h-24 border-t-2 border-r-2 border-accent pointer-events-none" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
